var _style, _path, _path2, _path3, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanejamentoEstategico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.7 41.7",
    style: {
      enableBackground: "new 0 0 41.7 41.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D3CBB9;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.6,2h0.8c1.8,0.1,3.6,0.4,5.1,1.2c1.5,0.8,3.3,2,4.4,3.3c0.2,0.3,0.5,0.6,0.7,0.9c0.4,0.6,0.8,1.2,1.1,1.9 c0.6,1.1,1.1,2.9,1.3,4.2c0,0.3,0,0.5,0.2,0.5h3.6c0.4,0,3.2-3.3,3.6-3.3h6.4V13c0,0.3-1.2,1.5-1.5,2c1.1,1.7,1.4,1.5,1.5,2.2v2.2 h-6.4c-0.4,0-3.1-3.3-3.5-3.3h-3.6c-0.3,0-0.2,0.4-0.4,1.2c-0.1,0.5-0.2,0.8-0.3,1.3c-0.2,0.8-0.5,1.5-0.8,2.2 c-0.5,1-1.1,1.9-1.9,2.8c-0.2,0.3-0.5,0.5-0.7,0.7c-1,1-2.2,1.9-3.6,2.5c-4.4,2-9.1,1.4-13.1-1.2c-1.8-1.2-3.3-3.2-4.3-5.1 c-0.9-1.8-1.2-3.7-1.2-6C0,11.2,1.7,8,3.8,5.8C5,4.7,6,4,7.5,3.2C9,2.5,10.8,2.1,12.6,2 M12.5,5.4c2,0,2.7,0,4.6,0.9 c2.4,1.1,4.3,3.3,5.1,5.8c0.1,0.5,0.4,1.3,0.4,1.8H26c0,0.5,0.1,0.7,0.1,1.2c0,0.4-0.1,0.6-0.1,1.2h-3.4c0,1-0.7,2.6-1,3.3 c-0.6,1-1.1,1.7-1.9,2.5c-1.3,1.3-3.7,2.6-6.3,2.6c-2.3,0-4.2-0.5-5.9-1.8c-0.2-0.1-0.5-0.4-0.6-0.5c-0.2-0.2-0.4-0.3-0.6-0.5 c-0.1-0.1-0.1-0.1-0.2-0.3c-0.1-0.2-0.2-0.2-0.3-0.3c-0.2-0.2-0.3-0.4-0.5-0.7c-2.4-3.6-2.3-8.1,0.3-11.4c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.2,0.1-0.2,0.3-0.3C7.7,6.8,10.1,5.4,12.5,5.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,14.8c0,2.7,1.1,4.7,3.2,6.2c0.3,0.2,0.7,0.5,1.1,0.6c2.7,1.2,5.6,0.7,7.8-1.2c0.7-0.6,1-1,1.5-1.8 c0.3-0.5,0.9-1.7,0.9-2.5H17c-0.3,1.4-2,2.9-3.6,2.9c-1,0-1.9-0.1-2.8-0.8c-0.2-0.1-0.4-0.3-0.5-0.5C8.6,16.1,8.5,14,10,12.3 c1.6-1.9,4.9-1.9,6.4,0.3c0.2,0.3,0.6,0.9,0.6,1.3h3.3c-0.1-0.3-0.2-0.9-0.3-1.3c-2-5.3-8.4-6.5-12.1-2.8 C6.6,11.1,5.7,12.8,5.7,14.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,14.8v0.4c0,0.8,0.8,1.6,1.8,1.6c1.6,0,2.5-1.8,1.4-3.1C13.5,12.6,11.3,13.3,11.3,14.8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11.4,33.6 18.7,33.6 18.7,39.4 21.9,39.4 21.9,29.2 29.3,29.2 29.3,39.4 32.4,39.4 32.4,25.6  39.7,25.6 39.7,39.4 39.7,41.1 39.7,41.7 9.1,41.7 9.1,39.4 11.4,39.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanejamentoEstategico);
export default __webpack_public_path__ + "static/media/planejamento_estategico.7fe9d2577617c4e33608ca71ab5357d9.svg";
export { ForwardRef as ReactComponent };